import templateUrl from "emun.on-demand/templates/position-overlay-prompt.htm";
import PositionOverlayPromptController from "emun.on-demand/templates/position-overlay-prompt.controller";
import open from "webmodals/open";

let positionOverlayPrompt = options => {
  let modalInstance = open({
    size: options.size || "xl",
    backdrop: options.backdrop || "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: PositionOverlayPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default positionOverlayPrompt;
